/**
Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    https://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
*/

/* eslint-disable */

// This source is updated based on https://github.com/HlidacStatu/codemirror-mode-liquid/blob/master/liquid.js

(function (mod) {
  require('codemirror/mode/xml/xml');
  require('codemirror/mode/javascript/javascript');
  require('codemirror/mode/markdown/markdown');
  require('codemirror/addon/selection/mark-selection');
  if (typeof exports == 'object' && typeof module == 'object')
    // CommonJS
    mod(require('codemirror'), require('codemirror/mode/xml/xml'));
  else if (typeof define == 'function' && define.amd)
    // AMD
    define(['../CodeMirror/lib/codemirror', '../CodeMirror/mode/xml/xml'], mod);
  // Plain browser env
  else mod(CodeMirror);
})(function (CodeMirror) {
  'use strict';

  CodeMirror.defineMode(
    'markdoc',
    function (config) {
      // This is a combination of Markdown and the Liquid templating engine
      // syntax's
      var htmlMode = CodeMirror.getMode(config, {
        name: 'text/markdown',
        multilineTagIndentFactor: 2,
        multilineTagIndentPastTag: false
      });
      // innerMode returns htmlMode after {%endcomment%} and {%endraw%} but we need to re-indent.
      var xmlMode = CodeMirror.getMode(config, {
        name: 'xml',
        htmlMode: true,
        multilineTagIndentFactor: 2,
        multilineTagIndentPastTag: false
      });
      xmlMode.electricInput = RegExp(
        xmlMode.electricInput.source +
        /|^\s*{%-?\s*end(comment|raw)\s*-?%}$/.source
      );

      function last(array) {
        return array[array.length - 1];
      }

      function tokenUntil(stream, state, untilRegExp) {
        if (stream.sol()) {
          for (var indent = 0; indent < state.indent; indent++) {
            if (!stream.eat(/\s/)) break;
          }
          if (indent) return null;
        }
        var oldString = stream.string;
        var match = untilRegExp.exec(oldString.substr(stream.pos));
        if (match) {
          stream.string = oldString.substr(0, stream.pos + match.index);
        }
        var result = stream.hideFirstChars(state.indent, function () {
          return htmlMode.token(stream, state.htmlState);
        });
        stream.string = oldString;
        return result;
      }

      return {
        startState: function () {
          return {
            states: [],
            indent: 0,
            quoteKind: null,
            htmlState: CodeMirror.startState(htmlMode)
          };
        },

        copyState: function (state) {
          return {
            states: state.states.concat([]),
            indent: state.indent,
            quoteKind: state.quoteKind,
            htmlState: CodeMirror.copyState(htmlMode, state.htmlState)
          };
        },

        token: function (stream, state) {
          switch (last(state.states)) {
            case undefined:
              var match;
              if (stream.match(/^{%-?\s*comment\s*-?%}/)) {
                state.indent += config.indentUnit;
                state.states.push('comment');
                return 'comment';
              } else if (stream.match(/^{%-?\s*raw\s*-?%}/)) {
                state.indent += config.indentUnit;
                state.states.push('raw');
                return 'keyword';
              } else if (stream.match(/^{{/)) {
                state.states.push('object');
                return 'keyword';
              } else if ((match = stream.match(/^{%-?\s*(\w*)/))) {
                if (match[1] == 'endcase')
                  state.indent -= 2 * config.indentUnit;
                else if (/^end/.test(match[1]))
                  state.indent -= config.indentUnit;
                else if (match[1] == 'case')
                  state.indent += 2 * config.indentUnit;
                else if (/^(if|unless|for|tablerow)$/.test(match[1]))
                  state.indent += config.indentUnit;
                state.states.push('tag');
                return 'keyword';
              }
              return tokenUntil(stream, state, /{{|{%/);

            case 'object':
            case 'tag':
              var match = stream.match(/^['"]/);
              if (match) {
                state.states.push('string');
                state.quoteKind = match[0];
                return 'string';
              } else if (
                stream.match(last(state.states) == 'object' ? /^}}/ : /^%}/)
              ) {
                state.states.pop();
              } else {
                stream.next();
              }
              return 'keyword';

            case 'comment':
              if (stream.match(/^.*?{%-?\s*\/comment\s*-?%}/)) {
                state.indent -= config.indentUnit;
                state.states.pop();
              } else {
                stream.skipToEnd();
              }
              return 'comment';

            case 'raw':
              if (stream.match(/^{%-?\s*endraw\s*-?%}/)) {
                state.indent -= config.indentUnit;
                state.states.pop();
                return 'keyword';
              }
              return tokenUntil(stream, state, /{%-?\s*endraw\s*-?%}/);

            case 'string':
              var match = stream.match(/^.*?(["']|\\[\s\S])/);
              if (!match) {
                stream.skipToEnd();
              } else if (match[1] == state.quoteKind) {
                state.quoteKind = null;
                state.states.pop();
              }
              return 'string';
          }
        },

        indent: function (state, textAfter, line) {
          var indent = state.indent,
            top = last(state.states);
          if (top == 'comment' && /^{%-?\s*endcomment\s*-?%}/.test(textAfter))
            indent -= config.indentUnit;
          else if (top == 'raw' && /^{%-?\s*endraw\s*-?%}/.test(textAfter))
            indent -= config.indentUnit;
          else if (top == undefined && /^{%-?\s*endcase/.test(textAfter))
            indent -= 2 * config.indentUnit;
          else if (top == undefined && /^{%-?\s*(when|end|els)/.test(textAfter))
            indent -= config.indentUnit;
          return indent + htmlMode.indent(state.htmlState, textAfter, line);
        },

        innerMode: function (state) {
          if (state.states.length && last(state.states) != 'raw') return null;
          else return { state: state.htmlState, mode: htmlMode };
        },

        electricInput: /^\s*{%-?\s*(when|end|endcase|els)$/,
        blockCommentStart: '{% comment %}',
        blockCommentEnd: '{% /comment %}',
        useInnerComments: false,
        fold: 'indent'
      };
    },
    'xml'
  );

  CodeMirror.defineMIME('text/x-markdoc', 'markdoc');
});
